import { css } from 'styled-components';

export default css`
  &.OrganizationInfo {
    padding: 0;
  }
`;
